import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { Button, Typography, Result, Form, Row, Col } from "antd";
import { Steps } from "antd";
import { FileSearchOutlined, DingtalkOutlined, CheckCircleOutlined, SearchOutlined } from "@ant-design/icons";
import ACTIONS from "../store/action";
import { selectIsFetching, selectTracking } from "../store/selector";
import { ApiNames } from "../api/api";
import { CarrierFormItem } from "./form/CarrierFormItem";
import { TrackingNumberFormItem } from "./form/TrackingNumberFormItem";
import ClearIcon from "../assets/svg/ClearIcon";

const { Step } = Steps;
const { Text } = Typography;

const getStatuses = (t) => [
  {
    order: 1,
    label: t("patient.tracking.status.proccessing"),
    isDone: () => true,
    icon: <FileSearchOutlined />
  },
  {
    order: 2,
    label: t("patient.tracking.status.transit"),
    isDone: (status) => status === "transit",
    icon: <DingtalkOutlined />
  },
  {
    order: 3,
    label: t("patient.tracking.status.delivered"),
    isDone: (status) => status === "delivery",
    icon: <CheckCircleOutlined />
  }
];

const StatesComponent = ({ trackingStates, currentStatus }) => {
  return (
    <Steps size="large" style={{ alignItems: "center", width: "100%" }}>
      {trackingStates.map((trackingStatus) => (
        <Step
          key={trackingStatus.order}
          status={currentStatus.order >= trackingStatus.order ? "finish" : "wait"}
          title={trackingStatus.label}
          icon={trackingStatus.icon}
        />
      ))}
    </Steps>
  );
};

const PatientTrackingTabComponent = ({ t, isFetching, tracking, getTrackingAct, resetTrackingAct }) => {
  const [form] = Form.useForm();
  const trackingStates = getStatuses(t);

  const onFinish = (values) => {
    const { carrier, trackingNumber } = values;
    getTrackingAct(carrier, trackingNumber);
  };

  const onReset = () => {
    form.resetFields();
    resetTrackingAct();
  };

  let currentStatus = null;
  trackingStates.forEach((trackingStatus) => {
    if (trackingStatus.isDone(tracking ? tracking.shipment?.statusCategory : null)) {
      currentStatus = trackingStatus;
    }
  });

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Form name="tracking" form={form} onFinish={(values) => onFinish(values)}>
        <Row style={{ width: "100%", backgroundColor: "#F9FBFF", padding: "16px 16px 0px 16px" }}>
          <Col span={5} style={{ paddingRight: 16 }}>
            <CarrierFormItem
              dataTMId="tt-carrier-dropdown"
              textArea={false}
              required={true}
              style={{ marginBottom: 0 }}
            />
          </Col>
          <Col span={5} style={{ paddingRight: 16 }}>
            <TrackingNumberFormItem textArea={false} required={true} style={{ marginBottom: 0 }} />
          </Col>
          <Col span={5}>
            <Form.Item>
              <Button
                data-tm-id="tt-track-package-btn"
                id="tt-track-package-btn"
                icon={<SearchOutlined />}
                disabled={isFetching}
                loading={isFetching}
                type="primary"
                htmlType="submit"
              >
                {t("patient.tracking.add_button")}
              </Button>
            </Form.Item>
          </Col>
        </Row>
        <Row style={{ width: "100%", backgroundColor: "#F9FBFF", padding: "0px 16px 0px 16px" }}>
          <Form.Item>
            <Button type="text" onClick={onReset} id="tt-track-package-reset">
              <div style={{ display: "flex", alignItems: "center" }}>
                <ClearIcon />
                <Text strong level={5} style={{ paddingLeft: 6, color: "#2B56A3" }}>
                  {t("clear")}
                </Text>
              </div>
            </Button>
          </Form.Item>
        </Row>
      </Form>
      {tracking && (
        <Result
          status="success"
          title={t("patient.tracking.success")}
          extra={<StatesComponent trackingStates={trackingStates} currentStatus={currentStatus} />}
        />
      )}
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  tracking: selectTracking,
  isFetching: selectIsFetching([ApiNames.Tracking])
});

const mapDispatchToProps = (dispatch) => ({
  getTrackingAct: (carrier, trackingNumber) => dispatch(ACTIONS.getTrackingAction(carrier, trackingNumber)),
  resetTrackingAct: () => dispatch(ACTIONS.setTracking(null))
});

const PatientTrackingTab = connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PatientTrackingTabComponent));

export { PatientTrackingTab };
